module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/logout/logout.component.scss
// module id = ./src/app/components/logout/logout.component.scss
// module chunks = main